"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _tabhead_styles = _interopRequireDefault(require("./tabhead_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// styles

/* ========== ~~~~~~~~~~ EXPORT : TAB HEAD ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_tabhead_styles.default)(function (props) {
  var handleTabSelect = function handleTabSelect(e) {
    return props.setActiveTab(props.id);
  }; // pass back ID to parent tabs component to set state there


  return _react.default.createElement("div", {
    id: props.id,
    className: "tabhead ".concat(props.classes.tabhead, " ").concat(props.isActive ? 'on' : 'off'),
    onClick: handleTabSelect
  }, _react.default.createElement("div", {
    className: "tabtitle"
  }, props.title), _react.default.createElement("div", {
    className: "tabdivider"
  }));
});

exports.default = _default;